"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as l } from "react/jsx-runtime";
import { useTheme as i } from "../../hooks.js";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: r, size: a = 24 } = _param, v = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = n(), c = r !== null && r !== void 0 ? r : t ? o.colors.inverse : o.colors.neutralHigh, { skinName: e } = i();
    return e.match(/^o2-new/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, v), {
        children: /* @__PURE__ */ l("path", {
            fill: c,
            d: "m9.2 5.038-.439.261a.576.576 0 0 0-.203.77.537.537 0 0 0 .738.209l.452-.266v.527c0 .309.24.556.54.556s.54-.247.54-.556v-.527l.451.266a.54.54 0 0 0 .738-.21.57.57 0 0 0-.203-.76l-.438-.26.438-.262a.564.564 0 0 0 .203-.76.53.53 0 0 0-.738-.209l-.452.266v-.527a.546.546 0 0 0-.54-.556c-.299 0-.539.247-.539.556v.518l-.452-.266a.535.535 0 0 0-.738.209.57.57 0 0 0 .203.76zm2.767 4.532c.156-.043.313-.076.484-.076.996 0 1.803.831 1.785 1.853v4.456c0 .27-.06.67-.222.979l-2.029 3.833a.713.713 0 0 1-.978.295.757.757 0 0 1-.286-1.007l2.03-3.834a.9.9 0 0 0 .046-.266v-4.456a.366.366 0 0 0-.36-.37.366.366 0 0 0-.36.37v1.482a.73.73 0 0 1-.72.741.73.73 0 0 1-.719-.741v-2.594a.366.366 0 0 0-.36-.37.366.366 0 0 0-.36.37v1.482a.73.73 0 0 1-.719.741.73.73 0 0 1-.72-.74V9.864a.366.366 0 0 0-.359-.37.366.366 0 0 0-.36.37v1.852a.73.73 0 0 1-.72.741.73.73 0 0 1-.719-.74V5.778a.366.366 0 0 0-.36-.37.366.366 0 0 0-.359.37v9.283a.73.73 0 0 1-.72.74.73.73 0 0 1-.719-.74v-2.594a.366.366 0 0 0-.36-.37.366.366 0 0 0-.36.37v3.71c0 .095.033.214.051.252l2.007 3.449a.755.755 0 0 1-.25 1.016.713.713 0 0 1-.987-.256L2.259 17.19A2.1 2.1 0 0 1 2 16.173v-3.71c0-1.026.812-1.857 1.803-1.857q.188.001.36.038V5.779c0-1.026.807-1.857 1.803-1.857.997 0 1.804.836 1.804 1.857v2.266q.173-.037.36-.038c.52 0 .986.233 1.314.599.253-.143.535-.228.844-.228.765 0 1.416.498 1.679 1.192m5.096-5.549a.535.535 0 0 0-.738-.209l-.452.266v-.522a.546.546 0 0 0-.54-.556c-.3 0-.54.247-.54.556v.527l-.451-.266a.53.53 0 0 0-.738.21.564.564 0 0 0 .203.76l.438.26-.438.262a.57.57 0 0 0-.203.76.537.537 0 0 0 .738.209l.452-.266v.527c0 .309.24.556.54.556s.539-.247.539-.556v-.527l.452.266a.54.54 0 0 0 .738-.21.564.564 0 0 0-.203-.76l-.438-.26.438-.262a.57.57 0 0 0 .203-.765m4.225 1.017.438.261c.262.152.35.49.203.77a.537.537 0 0 1-.738.209l-.452-.266v.527c0 .309-.24.556-.54.556s-.54-.247-.54-.556v-.527l-.451.266a.54.54 0 0 1-.738-.21.57.57 0 0 1 .203-.76l.438-.26-.439-.262a.564.564 0 0 1-.202-.76.53.53 0 0 1 .738-.209l.452.266v-.527c0-.309.24-.556.54-.556.299 0 .539.247.539.556v.518l.452-.266a.535.535 0 0 1 .738.209.57.57 0 0 1-.203.76z"
        })
    })) : e.match(/^o2/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, v), {
        children: /* @__PURE__ */ l("path", {
            fill: c,
            d: "m9.2 5.038-.439.261a.576.576 0 0 0-.203.77.537.537 0 0 0 .738.209l.452-.266v.527c0 .309.24.556.54.556s.54-.247.54-.556v-.527l.451.266a.54.54 0 0 0 .738-.21.57.57 0 0 0-.203-.76l-.438-.26.438-.262a.564.564 0 0 0 .203-.76.53.53 0 0 0-.738-.209l-.452.266v-.527a.546.546 0 0 0-.54-.556c-.299 0-.539.247-.539.556v.518l-.452-.266a.535.535 0 0 0-.738.209.57.57 0 0 0 .203.76zm2.767 4.532c.156-.043.313-.076.484-.076.996 0 1.803.831 1.785 1.853v4.456c0 .27-.06.67-.222.979l-2.029 3.833a.713.713 0 0 1-.978.295.757.757 0 0 1-.286-1.007l2.03-3.834a.9.9 0 0 0 .046-.266v-4.456a.366.366 0 0 0-.36-.37.366.366 0 0 0-.36.37v1.482a.73.73 0 0 1-.72.741.73.73 0 0 1-.719-.741v-2.594a.366.366 0 0 0-.36-.37.366.366 0 0 0-.36.37v1.482a.73.73 0 0 1-.719.741.73.73 0 0 1-.72-.74V9.864a.366.366 0 0 0-.359-.37.366.366 0 0 0-.36.37v1.852a.73.73 0 0 1-.72.741.73.73 0 0 1-.719-.74V5.778a.366.366 0 0 0-.36-.37.366.366 0 0 0-.359.37v9.283a.73.73 0 0 1-.72.74.73.73 0 0 1-.719-.74v-2.594a.366.366 0 0 0-.36-.37.366.366 0 0 0-.36.37v3.71c0 .095.033.214.051.252l2.007 3.449a.755.755 0 0 1-.25 1.016.713.713 0 0 1-.987-.256L2.259 17.19A2.1 2.1 0 0 1 2 16.173v-3.71c0-1.026.812-1.857 1.803-1.857q.188.001.36.038V5.779c0-1.026.807-1.857 1.803-1.857.997 0 1.804.836 1.804 1.857v2.266q.173-.037.36-.038c.52 0 .986.233 1.314.599.253-.143.535-.228.844-.228.765 0 1.416.498 1.679 1.192m5.096-5.549a.535.535 0 0 0-.738-.209l-.452.266v-.522a.546.546 0 0 0-.54-.556c-.3 0-.54.247-.54.556v.527l-.451-.266a.53.53 0 0 0-.738.21.564.564 0 0 0 .203.76l.438.26-.438.262a.57.57 0 0 0-.203.76.537.537 0 0 0 .738.209l.452-.266v.527c0 .309.24.556.54.556s.539-.247.539-.556v-.527l.452.266a.54.54 0 0 0 .738-.21.564.564 0 0 0-.203-.76l-.438-.26.438-.262a.57.57 0 0 0 .203-.765m4.225 1.017.438.261c.262.152.35.49.203.77a.537.537 0 0 1-.738.209l-.452-.266v.527c0 .309-.24.556-.54.556s-.54-.247-.54-.556v-.527l-.451.266a.54.54 0 0 1-.738-.21.57.57 0 0 1 .203-.76l.438-.26-.439-.262a.564.564 0 0 1-.202-.76.53.53 0 0 1 .738-.209l.452.266v-.527c0-.309.24-.556.54-.556.299 0 .539.247.539.556v.518l.452-.266a.535.535 0 0 1 .738.209.57.57 0 0 1-.203.76z"
        })
    })) : /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, v), {
        children: /* @__PURE__ */ l("path", {
            fill: c,
            d: "m15.857 2.473 5.662 5.69c.21.21.322.481.324.77a1 1 0 0 1-.29.708c-.763.768-1.586 1.222-2.463 1.37l-2.532 2.552c.347 2.025-.376 3.952-2.143 5.734a1.33 1.33 0 0 1-.947.412 1.2 1.2 0 0 1-.86-.359L9.09 15.804 3.222 21.66a.626.626 0 0 1-.886-.003.634.634 0 0 1 .003-.89l5.866-5.855-3.443-3.468a1.24 1.24 0 0 1-.361-.876c0-.334.126-.645.361-.88l.031-.034c2.19-2.204 4.263-2.448 5.72-2.196l2.53-2.549c.137-.876.58-1.694 1.316-2.437a1.04 1.04 0 0 1 1.498 0m2.496 7.499a.62.62 0 0 1 .376-.182c.627-.065 1.207-.353 1.77-.877L15.112 3.5c-.52.577-.798 1.16-.857 1.764a.62.62 0 0 1-.18.384l-2.918 2.938a.61.61 0 0 1-.585.168c-1.673-.397-3.32.202-4.894 1.788l-.028.03 3.84 3.863.02.013q.015.007.028.018a.1.1 0 0 1 .018.027l.013.02 3.922 3.944c1.585-1.607 2.168-3.257 1.778-4.96a.63.63 0 0 1 .165-.586z"
        })
    }));
}, d = s;
export { d as default };
